<template>
    <div>
        <center-element aria-label="Lista de parcelas" role="presentation" class="contrasteExtra">
            <v-card class="contrasteExtra px-0 no-outline" style="min-width: 295px">
                <blockquote class="text-center blockquote acessibilidade" v-if="items.length === 0">Não há parcelas em aberto para esta dívida.</blockquote>
                <v-list role="list" id="cardParcela" class="contrasteExtra" style="width: 100%">
                    
                    <div role="listitem" v-for="(item,i) in items" :key="i"> 
                        <div role="group">         
                            <v-list-tile  class="tempParcela" >
                                <v-list-tile-content >
                                    <table role="grid" style="width: 100%;">                            
                                        <tbody>
                                            <tr role="row"> 
                                                
                                                <td role="gridcell" :aria-label="'Valor ' + item.VrParcela + '.'" class="text-left "  style="font-size: 14px;border: none">R${{item.VrParcela | formataValor}}</td>
                                                <td role="gridcell" :aria-label="'Data ' + item.DtVencimento + '.'" class="text-right " style="font-size: 14px;border: none ">{{item.DtVencimento}}</td>
                                                <td rowspan="2" class="text-right">
                                                   <button class="btn dropdown-toggle bg-verde-dark" style="min-width: 160px;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-dollar-sign pr-2"></i>
                                                        Boleta
                                                    </button>
                                                    <div class="dropdown-menu">
                                                        <button class="dropdown-item" @click="enviarBoletaEmail(item.SqParcela)">
                                                            <i class="fas fa-envelope pr-2 corIconesToolbar"></i>
                                                            Enviar Email
                                                        </button>
                                                        <div class="dropdown-divider"></div>
                                                        <button class="dropdown-item" @click="imprimirBoleta(item.UrlBoleta, item.SqParcela)">
                                                            <i class="fas fa-print pr-2 corIconesToolbar"></i>
                                                            Imprimir
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr role="row">
                                                <td role="gridcell" :aria-label="'Parcela: ' + item.SqParcela + '.'" class="" style="font-size: 14px;border: none">Parcela {{item.SqParcela}}</td>
                                                <td role="gridcell" :aria-label="item.Atraso + ' dias de atraso.'" class="text-right " style="font-size: 14px;border: none">{{item.Atraso}} dias</td>
                                            </tr>
                                        </tbody>
                                    </table>        
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- v-if="i < items.length-1" :key="`divider-${i}`" -->
                            <v-divider aria-hidden="true" class="borderWhite" ></v-divider>
                        </div>
                    </div>
                </v-list>
            </v-card>
        </center-element>
    </div>
</template>
<script>
import CenterElement from './MyComponents/CenterElement.vue'
import bus from '@/service/bus'
import {getDivida_Parcela} from '@/service/service_autoatendimento/autoatendimento'
import {postBoletaEmailUnimedBelem} from '@/service/service_autoatendimento/boleta'
import {gerarEventoAutomatico} from '@/service/service_autoatendimento/unimedBelem'
import $divida from './_mixins/divida'
export default {
    components: {CenterElement},
    mixins: [$divida],
    props: ['divida'],
    data() {
        return {
            items: []
        }
    },
    mounted() {
        this.carregaParcelas()
    },
    methods: {
        carregaParcelas(){
            bus.$emit('load-in', {text: 'Carregando'})
            getDivida_Parcela(this.divida.ChaveDivida).then((response)=>{
                this.items = response.data.Retorno
                bus.$emit('load-out')
            }).catch(()=>{
                bus.$emit('load-out')
            })
        },
        async imprimirBoleta(url, sqParcela) {
            try {
                let chaveBase64 = this.DividaBase64(this.divida.ChaveDivida)
                await gerarEventoAutomatico(chaveBase64, sqParcela)
                window.open(url)
            } catch(er) {
                this.$swal.showValidationMessage(`Erro: ${er.message}`)
            }
        },
        enviarBoletaEmail(sqParcela) {
            this.$swal({
                input: 'email',
                title: 'Informe o e-mail de destino:',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText:'Enviar',
                reverseButtons: true,
                inputAttributes: {
                    id: 'myInput',
                    maxlength: 50
                },
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: (ret) => {
                    let obj = {
                        emailDestino: ret
                    }
                    try {
                        let chaveBase64 = this.DividaBase64(this.divida.ChaveDivida)
                        return postBoletaEmailUnimedBelem(chaveBase64, sqParcela, obj).then(() => {
                        }).catch(error => {
                            this.$swal.showValidationMessage(`Erro: ${error.message}`)
                        })
                    } catch (er) {
                        this.$swal.showValidationMessage(`Erro: ${er.message}`)
                    }
                }
            }).then((result) => {
                if(result.value) {
                    this.$swal({
                        type: 'success',
                        title: 'E-mail enviado!'
                    })
                }
            })   
        },
    }
}
</script>